import * as types from './constants';

// Get Creator Monthly Sales
export const getCreatorMonthlySalesRequest = data => (
  { type: types.GET_CREATOR_MONTHLY_SALES_REQUEST, payload: data }
);

export const getCreatorMonthlySalesDone = data => (
  { type: types.GET_CREATOR_MONTHLY_SALES_DONE, payload: data }
);

export const getCreatorMonthlySalesFailed = (errors, error) => (
  {
    type: types.GET_CREATOR_MONTHLY_SALES_FAILED,
    payload: {
      errors_api: errors || {},
      status: error?.response?.status || null
    }
  }
);

export const getCreatorMonthlySalesReset = () => (
  { type: types.GET_CREATOR_MONTHLY_SALES_RESET }
);
